import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../src/components/UserSideBar';
import '../../src/styles/dashboardUser.css';

const DashboardPageUser = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar si estamos en mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setIsSidebarOpen(false);
      }
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Controlar el scroll del body cuando el sidebar está abierto en mobile
  useEffect(() => {
    if (isMobile && isSidebarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }

    return () => document.body.classList.remove('sidebar-open');
  }, [isMobile, isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      {/* Botón toggle para mobile */}
      {isMobile && (
        <button
          className="user-sidebar-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 12h18M3 6h18M3 18h18" />
          </svg>
        </button>
      )}

      {/* Overlay para cerrar sidebar en mobile */}
      {isMobile && (
        <div
          className={`user-sidebar-overlay ${isSidebarOpen ? 'active' : ''}`}
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
     
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={closeSidebar}
        />
     

      {/* Contenido principal */}
      < main className="dashboardUser" >
        <div className="dashboardUser-content">
          <Outlet /> {/* Aquí se renderiza el contenido según la ruta */}
        </div>
      </main >
    </>
  );
};

export default DashboardPageUser;